import * as React from 'react';
import * as S from './styles';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store/types';
import { getLMOperationHoursAPI, postLMOperationHoursAPI } from './state/actions';
import { SectionWrapper } from 'common/baseComponents';
import { ReactComponent as IconSpecialHours } from 'common/images/icon-special-hours.svg';
import InputIconField, { InputIconFieldAction, InputIconFieldState } from 'components/InputIcon';
import { serviceLoading } from 'common/loaderReducer';
import { GET_LMOPERATIONHOURS_API_REQUEST, POST_LMOPERATIONHOURS_API_REQUEST } from 'features/Dealers/Listings/OperationHours/state/actionTypes';
import ViewOperationHours from 'features/Dealers/Listings/OperationHours/ViewOperationHours';
import EmptySpecialHours from 'features/Dealers/Listings/SpecialHours/EmptySpecialHours';
import EditSpecialHours from 'features/Dealers/Listings/SpecialHours/EditSpecialHours';
import Loader from 'components/Loader';
import { getListingSyncErrors } from 'features/Dealers/Listings/state/actions';
import { getDealerListingsWithErrors } from 'features/Dealers/Listings/state/actions';
import { getSyncError } from 'features/Dealers/Listings/utils';
import * as _ from 'lodash';
import { OperationHour } from 'features/Dealers/Listings/OperationHours/state/types';
import { regexHourFormat } from 'features/Dealers/Listings/Data/state/utils';
import EditOperationHours from './EditOperationHours';
import { PhoneSourceNumber } from '../Data/state/types';
import { DealerHour } from '../Info/state/types';
import { Item } from 'features/Dealers/Reviews/Widget/DragReviews/styles';
import EmptyOperationHours from './EmptyOperationHours';


export interface OperationHoursProps {
  operationTypesArray: PhoneSourceNumber[]
}


export interface OperationHourFormat extends OperationHour {
  format?: {
    openDay?: string;  // MONDAY, FRIDAY
    openTime: string; //08:00
    closeDay?: string;
    closeTime: string; //18:59     ;
  }  
}

export interface OperationHourType {
  type: string
  operationHours: OperationHour[]    
}



const OperationHours:  React.FC<OperationHoursProps> = (props) => {
  const dispatch = useDispatch();
  const [firstLoad, setFirstLoad] = React.useState(true)

  const [editingState, setEditingState] = React.useState(InputIconFieldState.VIEW);
  const [operationHoursState, setOperationHoursState] = React.useState<OperationHourFormat[]>([]);
  const [operationHoursInfo, setOperationHoursInfo] = React.useState<OperationHourFormat[]>([]);
  const [operationHoursGBP, setOperationHoursGBP] = React.useState<OperationHourFormat[]>([]);
  const [operationType, setOperationType]= React.useState("");

  

  const {
    isLoading,
    operationHours,
    isSaving,
    dealerId,
    listingSyncErrors,
    selectedDealerId,
    selectedListingId,
    infoHours,
    hoursGBP,
    currentListing
  } = useSelector((rootState: RootState) => {
    return {
      isLoading: serviceLoading(rootState, [GET_LMOPERATIONHOURS_API_REQUEST]),
      isSaving: serviceLoading(rootState, [POST_LMOPERATIONHOURS_API_REQUEST]),      
      operationHours: rootState.dealers.listing.currentListing.operationHours,      
      dealerId: rootState.dealers.dealer.selectedDealer?.id,
      listingSyncErrors: rootState.dealers.listing.listings.listingSyncErrors,
      selectedDealerId: rootState.dealers.dealer.selectedDealer?.id,
      selectedListingId: rootState.dealers.listing.listings.selectedListingId,
      infoHours: rootState.dealers.listing.currentListing.info.info?.infoHours,
      hoursGBP: rootState.dealers.listing.currentListing.enginePreview.gmbPreview?.hoursOfOperation,
      currentListing: rootState.dealers.listing.currentListing,
    }
  }, shallowEqual);

  const setOperationHoursFromSelector = () => {
    if (operationHours && operationHours.operationHours &&  operationHours?.operationHours.length) 
    {
      setOperationType(operationHours.operationHoursType);
      setOperationHoursState(_.cloneDeep(operationHours.operationHours));
    }
    else setOperationHoursState([]);
  }

  const convertTo24H=(time:string): string=>{
    if (time)
      {
      if (time.toUpperCase().indexOf("AM")>0)
      {
        return time.replace("AM","").trim()
      }
      if (time.toUpperCase().indexOf("PM")>0)
      {
        let arrayTime = time.replace("PM","").trim().split(":")
        let hour = parseInt(arrayTime[0]);
        hour = hour + 12
        return `${hour}:${arrayTime[1]}`
      }
      }

      return time
  }


  const UpdateOperationHoursTypeArrayGBP = (operationHours:{day:string, hours:string}[]) =>{
    let operationHourArray : OperationHourFormat[] = [];    
    if (operationHours){
      operationHours.map((operationHour, index)=>{

        let timeArray = operationHour.hours.split('-')

        let openTime = convertTo24H(timeArray[0]);
        let closeTime = convertTo24H(timeArray[1]);



        let item : OperationHour = {
            openDay: operationHour.day,
            openTime: openTime,
            closeDay: operationHour.day,
            closeTime: closeTime  
        }
        operationHourArray.push(item)
      })
      setOperationHoursGBP(operationHourArray)
    }    
  }

  const UpdateOperationHoursTypeArrayInfo = (operationHours:DealerHour[]) =>{
    let operationHourArray : OperationHourFormat[] = [];    
    if (operationHours){
      operationHours.map((operationHour, index)=>{

        
        let timeArray = operationHour.formattedHour.split('-')

        let openTime = convertTo24H(timeArray[0]);
        let closeTime = convertTo24H(timeArray[1]);


        let item : OperationHour = {
            openDay: operationHour.day,
            openTime: openTime,
            closeDay: operationHour.day,
            closeTime: closeTime 
        }
        operationHourArray.push(item)
      })
      setOperationHoursInfo(operationHourArray)      
    }    
  }

  React.useEffect(() => {
    if (selectedListingId && selectedListingId != "") {      
      dispatch(getLMOperationHoursAPI(selectedListingId));
    }
  }, [selectedListingId]);

  React.useEffect(() => {    
    setOperationHoursFromSelector();
  }, [JSON.stringify(operationHours?.operationHours)]);

  React.useEffect(() => {    
    if (hoursGBP)
      UpdateOperationHoursTypeArrayGBP(hoursGBP)    
  }, [hoursGBP]);

  React.useEffect(() => {
    if (infoHours)
      UpdateOperationHoursTypeArrayInfo(infoHours)    
  }, [infoHours]);




  React.useEffect(() => {
    if (!firstLoad && !isSaving && selectedListingId && selectedListingId != "" && selectedDealerId) {
      dispatch(getListingSyncErrors(selectedListingId ?? ""));
      dispatch(getDealerListingsWithErrors(selectedDealerId ?? ""));
    }
    setFirstLoad(false);
  }, [isSaving])

  if (isLoading || !selectedListingId || selectedListingId == "") {
    return <Loader />;
  }

  const isValidTimeRange=(openTime?:string, closeTime?: string)=>
  {
    if (openTime!="" && openTime!= undefined && closeTime!="" && closeTime!= undefined)
    {
      const [hours1, minutes1] = openTime.split(':');
      const [hours2, minutes2] = closeTime.split(':');
      const dateOpen = new Date(2000, 0, 1, +hours1, +minutes1);
      const dateClose = new Date(2000, 0, 1, +hours2, +minutes2);
      if (dateOpen.getTime() > dateClose.getTime()) {
        return false
      } else 
        return true;
    }
    return false;
  }

  const onFieldActionClick = (action: InputIconFieldAction) => {
    switch (action) {
      case InputIconFieldAction.SAVE:
        {
          setEditingState(InputIconFieldState.VIEW);
          let newOperationHoursState: OperationHour[]=[];        
          operationHoursState.map((operationHour, index) => {                       
            const openTime = regexHourFormat(operationHour.openTime);              
            const closeTime = regexHourFormat(operationHour.closeTime);            
            if (isValidTimeRange(openTime,closeTime))
            {
              let item : OperationHour ={
                openDay : operationHour.openDay,
                openTime: openTime??"",
                closeDay : operationHour.closeDay,
                closeTime: closeTime??""                
              }
              newOperationHoursState.push(item)
            }            
            setOperationHoursState(newOperationHoursState)
          })          
          dispatch(postLMOperationHoursAPI(selectedListingId ?? "", {operationHoursType: operationType,  operationHours: newOperationHoursState }));
          break;
        }
      case InputIconFieldAction.EDIT:
        {
          setEditingState(InputIconFieldState.EDIT);
          break;
        }
      case InputIconFieldAction.CANCEL:
        {
          setEditingState(InputIconFieldState.VIEW);
          setOperationHoursFromSelector();
        }
    }
  }

  const renderOperationHours = () => {

    if (editingState === InputIconFieldState.VIEW || editingState === InputIconFieldState.LOADING) {
      if (operationHours?.operationHours?.length) {
        return (
          <ViewOperationHours
            operationHoursState={operationHoursState}            
          />
        )
      } else {
        return <EmptyOperationHours />
      }
    } else if (editingState === InputIconFieldState.EDIT) {
      return (
        <EditOperationHours
          operationHoursState={operationHoursState}      
          operationHoursGBP= {operationHoursGBP}
          operationHoursInfo={operationHoursInfo}  
          operationTypesArray={props.operationTypesArray}
          operationHoursType={operationType}
          setOperationHoursState={setOperationHoursState}  
          setOperationTypeState= {setOperationType}
        />
      )
    }
  }





  return (
    <S.GeneralContainer>
      <SectionWrapper>
        <InputIconField
          label={'Hours'}
          state={isSaving ? InputIconFieldState.LOADING : editingState}
          renderValue={renderOperationHours}
          renderIcon={() => { return (<S.IconContainer><IconSpecialHours /></S.IconContainer>) }}
          showAlertIcon={getSyncError('operationHours', listingSyncErrors) ? true : false}
          alertToolTip={getSyncError('operationHours', listingSyncErrors)}
          showEditErrorMessage={getSyncError('operationHours', listingSyncErrors) ? true : false}
          editErrorMessage={getSyncError('operationHours', listingSyncErrors)}
          onActionClick={(action: InputIconFieldAction) => { onFieldActionClick(action) }}
          disabled={false}
          disableBackground={true}
        />
      </SectionWrapper>
    </S.GeneralContainer>
  )
}

export default OperationHours;

